// var $formWrap = $('.application-form-wrap');
//
// if($formWrap.length) {
//     let hash = window.location.hash
//
//     if(!hash){
//         selectFirstTab()
//     }
// }
//
// function selectFirstTab(){
//     selectTab($formWrap.find('.form-mini__item.is-main').first())
//
// }
//
// function selectTab($tab){
//     $tab.removeClass('is-future').addClass('is-active')
// }
const systemsightFormConditions = require('/Framework/assets/js/cms-form-conditions')


$(function () {

    var $form = $('.application-form');
    if (!$form.length) return;

    //flag'as, nurodantis, kad jei zingnyje nera klaide, reiktu pereiti i kita
    let showNextStepAfterValidation = false;
    let validatedSteps = new Set();

    $form.on('ajax-form.done', function (){
        if(showNextStepAfterValidation){
            //jei tai next actionas, patikrina ar zigsnis neturi klaidu ir jei neturi pereina i kita zingsni
            showNextStepAfterValidation = false;
            //$form.data('validate_scope', null);
            if($(steps[current]).find('.form-group.has-error').length === 0){
                validatedSteps.add(current);
                setStep(current + 1);
            }
        }else{
            //pazymi ta zingsni, kuriame yra bent viena klaida
            // steps.some(function (el, i) {
            //     if($(el).find('.form-group.has-error').length){
            //         setStep(i)
            //         return true;
            //     }
            // })
        }

        steps.forEach(function (el, i) {
            let $el = $(el);
            let count = $el.find('.form-group.has-error').length
            let $errCounter = $miniList.find('.form-mini__item.is-main').eq(i).find('[data-errors-counter]');
            if(count > 0){
                $errCounter.html(count).removeClass('d-none')
            }else{
                $errCounter.addClass('d-none')
            }
        });

    })

    var $root = $form.find('.main.conditional-fields');
    if (!$root.length) $root = $form;

    var steps = $root.find('.form-group-container').filter(function () {
        return $(this).parents('.form-group-container').length === 0;
    }).toArray();
    if (!steps.length) return;
    steps.forEach(function (el, i) {
        el.setAttribute('data-step-index', i);
    });

    // Kairioji navigacija
    var $mini = $('.form-mini');
    var $miniList = $mini.find('.form-mini__list');
    if (!$miniList.length) $miniList = $('<ol/>', {class: 'form-mini__list'}).appendTo($mini);


    var $topControls = $('.form-top-controls').first();
    var $stepIndicator = null;
    if ($topControls.length) {
        $stepIndicator = $('<div class="step-indicator" aria-hidden="true">' +
            '<span class="step-count">0/0</span>' +
            '<span class="step-title"></span>' +
            '</div>');
        $topControls.append($stepIndicator);
    }


    var $secondHeader = $('header.second-header, header.second-header.sticky'); // try both selectors
    function syncMiniTop() {
        if (!$mini.length) return;
        var headerH = 0;
        if ($secondHeader.length) {
            headerH = 0;
            $secondHeader.each(function(){
                var h = $(this).is(':visible') ? $(this).outerHeight() : 0;
                if (h > headerH) headerH = h;
            });
        }
        $mini.css({
            'position': 'sticky',
            'top': (headerH) + 'px',
            'align-self': 'start'
        });
    }
    var _syncTimer;
    $(window).on('load resize', function(){
        clearTimeout(_syncTimer);
        _syncTimer = setTimeout(syncMiniTop, 80);
    });
    syncMiniTop();

    if (window.MutationObserver && $secondHeader.length) {
        var headerObserver = new MutationObserver(function() {
            clearTimeout(_syncTimer);
            _syncTimer = setTimeout(syncMiniTop, 60);
        });
        $secondHeader.each(function(){
            headerObserver.observe(this, { attributes: true, childList: true, subtree: true });
        });
    }

    // Step actions + mygtukai
    var $prev = $form.find('.btn-step-prev');
    var $next = $form.find('.btn-step-next');
    var $transitionBtns = $form.find('button[data-transition]:not([data-transition="application_cancel"])');//.filter(':not[data-transition="application_cancel"]');
    var $finalWrap = $form.find('.js-final-actions');
    var $actions = $form.find('.step-actions');
    var $right = $actions.find('.gap-2').first();

    var $finalBtns = $finalWrap.find('button, [type="submit"], input[type="submit"]');
    if ($finalBtns.length) {
        $finalBtns.addClass('only-final').detach().appendTo($right).hide();
        $finalWrap.remove();
    }

    function cleanText($h) {
        var $c = $h.clone();
        $c.find('em,i,span').remove();
        return $.trim($c.text());
    }

    function headIn($block) {
        return $block.find('> .row h5[id], > .d-flex h5[id], > h5[id]').first();
    }

    function directChildren($parent) {
        return $parent.find('.form-group-container').filter(function () {
            return $(this).parents('.form-group-container').length === 1;
        });
    }

    // function buildMini() {
    //     $miniList.empty();
    //     $(steps).each(function (i, el) {
    //         var $main = $(el), $hMain = headIn($main);
    //         if (!$hMain.length) return;
    //
    //         var $li = $('<li/>', {class: 'form-mini__item is-main', 'data-step': i});
    //         $li.append($('<a/>', {href: '#' + $hMain.attr('id'), text: cleanText($hMain)}));
    //
    //         var $subs = $('<ol class="form-mini__subs"></ol>');
    //         directChildren($main).each(function () {
    //             var $h = headIn($(this));
    //             if (!$h.length) return;
    //             var $subLi = $('<li class="form-mini__item is-sub"></li>');
    //             $subLi.append($('<a/>', {href: '#' + $h.attr('id'), text: cleanText($h)}));
    //             $subs.append($subLi);
    //         });
    //         $li.append($subs);
    //         $miniList.append($li);
    //     });
    // }

    function markErrorsFor(stepIdx) {
        var $step = $(steps[stepIdx]);

        $miniList.find('a').removeClass('has-error').removeAttr('title');
        $step.find('h5').removeClass('has-error-icon');

        $step.find('.form-group-container').each(function () {
            var $sec = $(this), $h = headIn($sec);
            if (!$h.length) return;

            if ($sec.find('.is-invalid, .error, .bg-danger, .form-group.has-error').length) {
                $miniList.find('a[href="#' + $h.attr('id') + '"]')
                    .addClass('has-error')
                    .attr('title', 'Yra klaidų');

                $h.addClass('has-error-icon');
            }
        });
    }


    var current = 0;
    var subOnScroll = null;

    function watchSubSections(stepIdx) {
        if (subOnScroll) {
            $(window).off('scroll', subOnScroll);
            subOnScroll = null;
        }

        var $step = $(steps[stepIdx]);
        var subsHeads = [];
        directChildren($step).each(function () {
            var $h = headIn($(this));
            if ($h.length) subsHeads.push($h.get(0));
        });

        $miniList.find('.is-sub > a').removeClass('is-active');
        if (!subsHeads.length) return;

        function updateActive() {
            var scrollPos = window.pageYOffset || document.documentElement.scrollTop || 0;
            // IMPORTANT: account for header height when computing active
            var headerH = 0;
            if ($secondHeader.length) {
                $secondHeader.each(function(){
                    var h = $(this).is(':visible') ? $(this).outerHeight() : 0;
                    if (h > headerH) headerH = h;
                });
            }
            var offset = headerH + 12; // little margin under header
            var targetLine = scrollPos + offset;

            var currentId = subsHeads[0].id;
            for (var i = 0; i < subsHeads.length; i++) {
                var hTop = subsHeads[i].getBoundingClientRect().top + scrollPos;
                if (hTop <= targetLine) currentId = subsHeads[i].id;
                else break;
            }
            $miniList.find('.is-sub > a').removeClass('is-active');
            $miniList.find('.is-sub > a[href="#' + currentId + '"]').addClass('is-active');
        }

        subOnScroll = function () {
            requestAnimationFrame(updateActive);
        };
        $(window).on('scroll', subOnScroll);
        updateActive();
    }

    function validateCurrentStep() {

        if($form.data('loading-additional-data')){
            //laukiam, kol bus uzkrautas po pavadinimas pagal reg numeri
            setTimeout(function (){
                validateCurrentStep();
            }, 100);
        }else{
            //nurodom formai, kokiam scope pazymeti klaidas
            $form.data('validate_scope', steps[current]);
            validate();
        }


    }

    function validate(){
        //nurodom, kad reikes persokti i kita zigsni po validacijos, jei nera klaidu
        showNextStepAfterValidation = true;
        //issaukiam formos validavima
        $form.find('button[value="validate"]').click();
    }

    function setStep(idx, dontAnimate) {

        if (idx < 0 || idx >= steps.length) return;
        current = idx;

        //Tikrinti duomenis mygtukas - tikrina tik aktyvaus etapo duomenis
        $form.data('validate_scope', steps[current]);

        // Tikrinti ar forma buvo paredaguota, pasalinam is validuotu step'u
        $(steps).off('change.formStep input.formStep');
        $(steps[current]).on('change.formStep input.formStep', 'input, select, textarea', function() {
            for (let i = current; i < steps.length; i++) {
                validatedSteps.delete(i);
            }
        });
        $(steps[current]).on('change.formStep', '.media-uploader', function() {
            for (let i = current; i < steps.length; i++) {
                validatedSteps.delete(i);
            }
        });

        // Rodyti tik aktyvų pagrindinį
        $(steps).hide().attr('aria-hidden', 'true');
        $(steps[current]).show().attr('aria-hidden', 'false');

        // Meniu būsenos + atidaryti tik aktyvaus sub'us
        $miniList.find('.form-mini__item.is-main').each(function (j, li) {
            li.classList.remove('is-active', 'is-done', 'is-future');
            if (j < current) li.classList.add('is-done');
            else if (j === current){
                li.classList.add('is-active');
                window.location.hash = $(li).find('[data-main-link]').attr('href').slice(1)
            }
            else li.classList.add('is-future');
            if(j === current){
                $(li).find('.form-mini__subs').removeClass('d-none')
            }else{
                $(li).find('.form-mini__subs').addClass('d-none')
            }
        });

        // mygtukai
        var isLast = (current === steps.length - 1);
        $prev.prop('disabled', current === 0);

        if (isLast) {
            $next.addClass('d-none').attr('aria-hidden', 'true');
            $transitionBtns.removeClass('d-none').attr('aria-hidden', 'false');
        } else {
            $next.removeClass('d-none').attr('aria-hidden', 'false');
            $transitionBtns.addClass('d-none').attr('aria-hidden', 'true');
        }

        $right.find('.only-final').toggle(isLast);

        if ($stepIndicator && $stepIndicator.length) {
            var total = steps.length || 0;
            $stepIndicator.find('.step-count').text((current + 1) + '/' + total);

            var $h = headIn($(steps[current]));
            var titleText = $h.length ? cleanText($h) : '';
            $stepIndicator.find('.step-title').text(titleText);
        }



        markErrorsFor(current);
        watchSubSections(current);

        if(!dontAnimate){
            $('html, body').stop(true).animate({scrollTop: $form.offset().top - 8}, 200);
        }

        if($(steps[current]).find('.form-group-container').length){
            $('.js-acc-toggle-all').removeClass('d-none')
        }else{
            $('.js-acc-toggle-all').addClass('d-none')
        }

        //set step desk
        let stepDesc = $(steps[current]).find('[data-group-desc]').first().html();
        if(stepDesc){
            $('[data-step-desc]').html(stepDesc);
        }else{
            $('[data-step-desc]').html()
        }

        systemsightFormConditions.checkInputs(
            $(steps[current])
        )

        if (current === 2) {
            const foundersApp = $(steps[current]).find('[data-list][data-owner]').data('foundersAddInputApp');
            if (foundersApp) {
                foundersApp.updateList();
            }
        }
    }

    function allPreviousStepsValidated(stepIdx) {
        for (let i = 0; i < stepIdx; i++) {
            if (!validatedSteps.has(i)) {
                return false;
            }
        }
        return true;
    }

    // Kairio meniu: pagrindinis -> perjungiam žingsnį
    $miniList.on('click', '.is-main > a', function (e) {
        e.preventDefault();
        let step = $(e.currentTarget).parent().index();

        // Jei žingsnis jau validuotas arba einam atgal, nedarom tikrinimo
        if (step <= current || validatedSteps.has(step)) {
            setStep(step);
        } else if (allPreviousStepsValidated(step)) {
            // Jei visi ankstesni žingsniai validuoti, perjungiam
            setStep(step);
        } else {
            setTimeout(function (){
                validateCurrentStep();
            }, 300)
        }
    });

    // Kairio meniu sub
    $miniList.on('click', '.is-sub > a', function () {
        //e.preventDefault();
        var href = this.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var id = href.slice(1);
        var target = document.getElementById(id);
        if (!target) return;

        $miniList.find('.is-sub > a').removeClass('is-active');
        $(this).addClass('is-active');

        var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
        window.scrollTo({top: top, behavior: 'smooth'});
    });

    // Atgal / Toliau
    $prev.on('click', function () {
        setStep(current - 1);
    });
    $next.on('click', function () {
        // Only validate if step hasn't been validated yet
        if (!validatedSteps.has(current)) {
            validateCurrentStep();
        } else {
            setStep(current + 1);
        }
    });

    // Submit – tik paskutiniame
    /*
    $form.on('submit', function (e) {
        if (current < steps.length - 1) {
            e.preventDefault();
            setStep(current + 1);
        }
    });
     */

    // Dinaminiai pokyčiai
    if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () {
            var $mainLi = $miniList.find('.is-main').eq(current);
            var $subs = $mainLi.find('.form-mini__subs').empty();
            directChildren($(steps[current])).each(function () {
                var $h = headIn($(this));
                if (!$h.length) return;
                var $subLi = $('<li class="form-mini__item is-sub"></li>');
                $subLi.append($('<a/>', {href: '#' + $h.attr('id'), text: cleanText($h)}));
                $subs.append($subLi);
            });
            $subs.show();
            watchSubSections(current);
            markErrorsFor(current);
        });
        mo.observe($root.get(0), {childList: true, subtree: true});
    }

    // START
    //buildMini();

    if (window.location.hash) {

        let $aHref = $mini.find(`a[href="${window.location.hash}"]`);

        if ($aHref.length) {
            if ($aHref.parent().hasClass('is-main')) {
                setStep($aHref.parent().index(), true);
            } else {
                setStep($aHref.closest('.is-main').index(), true);
                $aHref.click();
            }
        } else {
            setStep(0, true);
        }

    } else {
        setStep(0, true);
    }

    //
});
